

































import { Vue, Component, Prop } from 'vue-property-decorator';
import FileAttach from '../fileattach/FileAttach.vue';
import { FileUpload } from '../../biz/FileUpload';
import { Session } from '../../utils/Session';
import { SupportPlanService } from '../../biz/remote/SupportPlanService';
import { SupportPlanAttach } from '../../../src_server/entity/generated/SupportPlanAttach';
import { dayjs, DTW_FORMAT_JA_SHORT } from '../../../src_server/common/momentExtends';
import { MessageDialog } from '../../utils/MessageDialog';
import { FileAndUrl } from '../fileattach/FileHandler';
@Component({
  components: { FileAttach },
  filters: {
    dateFormat: (dt: Date) => {
      return dayjs(dt).format(DTW_FORMAT_JA_SHORT);
    },
  },
})
export default class FileAttachSection extends Vue {
  @Prop({ default: true })
  private isEditMode!: boolean;
  @Prop({ default: '' })
  private user_id!: string;

  private support_plan_id = 0;
  private comment = '';
  private items: SupportPlanAttach[] = [];
  private fileDisplay = true;
  // 添付ファイル
  private attachedFiles: FileAndUrl[] = [];

  addFile(file: FileAndUrl) {
    this.attachedFiles.push(file);
    this.reset();
  }

  delFile(index: number) {
    this.attachedFiles.splice(index);
    this.reset();
  }

  reset() {
    this.fileDisplay = false;
    this.$nextTick(() => {
      this.fileDisplay = true;
    });
  }

  async fileUpload() {
    const paths = await this.fileAttachUpload();
    const biz = new SupportPlanService();
    const response = await biz.addFileOrComment(this.user_id, Session.getSessionUserId(), this.comment, paths);
    console.log('fileUpload', response.data);
    response.data.forEach((item) => this.items.push(item));

    await MessageDialog.alert('登録しました。');

    this.comment = '';
    this.attachedFiles = [];
    this.reset();
  }

  /**
   * 添付ファイルのアップロードとパス返却
   * @returns ファイルのパス情報を返す
   */
  async fileAttachUpload(): Promise<string[]> {
    const files: string[] = [];
    for (const file of this.attachedFiles) {
      const fileService = new FileUpload();
      const response = await fileService.fileUpload(Session.getSessionUserId(), 'report_attach', file.file);
      files.push(response);
    }
    return files;
  }

  async created() {
    const biz = new SupportPlanService();
    const response = await biz.getFileOrCommentByUser(this.user_id);
    this.items = response.data;
  }

  async deleteFileOrComment(item: SupportPlanAttach) {
    const isOK = await MessageDialog.confirm('添付ファイルを削除してよろしいですか?');
    if (!isOK) {
      return;
    }
    if (!item.support_plan_attache_id) {
      await MessageDialog.systemError('個人支援計画添付ファイルID', '削除時', item.support_plan_attache_id);
      return;
    }
    const biz = new SupportPlanService();
    await biz.deleteFileOrComment(item.support_plan_attache_id);

    const find = this.items.findIndex((i) => i.support_plan_attache_id === item.support_plan_attache_id);
    this.items.splice(find, 1);
  }
}
